export enum eErrorMode {
  NONE,
  QUEOVAL,
  GENERIC
}

//////export class DataErrorModel {
//////  status: number;
//////  error: MessageError;
//////  message: string;
//////  noerror: boolean;
//////}

//////export class MessageError {
//////  Message: string;
//////}
